import styled from 'styled-components';

export const StyledNotificationsDropdown = styled.div`
  display: flex;
  flex-direction: column;
  height: 498px;
  width: 334px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
`;

export const NotificationsPickerContainer = styled.div`
  padding: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
`;

export const NotificationsPicker = styled.div`
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-radius: 3px;
  display: flex;
  height: 36px;
  overflow: hidden;
`;

export const LabelButton = styled.button`
  width: 50%;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.DEEP_GREY};
  background-color: ${({ theme, selected }) =>
    selected ? theme.COLORS.TERTIARY : theme.COLORS.BASE};
  color: ${({ theme, selected }) =>
    selected ? theme.COLORS.BASE : theme.COLORS.NEUTRAL_30};
  font-family: ${({ theme, selected }) =>
    selected ? theme.FONT.SEMI_BOLD : theme.FONT.REGULAR};
  outline: none;
  border: none;
  cursor: pointer;
`;

export const ListContainer = styled.div`
  flex-grow: 1;
  overflow-y: scroll;
`;

export const ItemContainer = styled.div`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  }
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const Details = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  margin-top: 6px;
  color: ${({ theme, isAlert }) =>
    isAlert ? theme.COLORS.NEUTRAL_30 : theme.COLORS.BASE_INVERTED};
`;

export const DateCreated = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  color: ${({ theme, isAlert }) =>
    !isAlert ? theme.COLORS.NEUTRAL_30 : theme.COLORS.BASE_INVERTED};
  margin-top: 6px;
`;

export const StatusLabel = styled.div`
  font-family: ${({ theme }) => theme.FONT.LIGHT};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  padding: 10px;
  margin-top: 20px;
  text-align: center;
`;

export const BoldedText = styled.span`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;
